// @Link: https://github.com/gatsbyjs/gatsby/issues/9193
function getVar(variable) {
  return (typeof window !== 'undefined') ? window.getComputedStyle(document.documentElement).getPropertyValue(variable) : null
}

export default getVar